import { InventoryItem } from 'lib/context';

export interface VINReel {
  itemId: number;
  vin: string;
  customerId: number;
  dealerId: number;
  status: VINReelStatus;
  videoUrl: string;
  thumbnailUrl: string;
  videoLength: number;
  gifUrl: string;

  inventoryItem?: InventoryItem;
}

export enum VINReelStatus {
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
  PENDING = 'pending',
}

export enum VINReelSortKey {
  CREATED_AT = 'createdAt',
  YEAR = 'year',
  MAKE = 'make',
  MODEL = 'model',
}
